module.exports = __webpack_public_path__ + "img/2025_PerformanceWomen.d4fe147d.jpg";